module.exports = __webpack_public_path__ + "img/credit_card__grey.6d91444f.svg";